/** Minimal Web Audio manager with user-gesture-safe, normalized procedural cues. */
export class AudioManager {
  private context: AudioContext | undefined;
  private master = 0.35;
  public setMaster(value: number): void {
    this.master = Math.max(0, Math.min(1, value));
  }
  public cue(kind: 'ui' | 'warning' | 'impact'): void {
    if (this.master <= 0) return;
    const context = this.context ?? new AudioContext();
    this.context = context;
    if (context.state === 'suspended') void context.resume();
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    oscillator.type = kind === 'warning' ? 'triangle' : 'sine';
    oscillator.frequency.value = kind === 'warning' ? 420 : kind === 'impact' ? 110 : 660;
    gain.gain.setValueAtTime(this.master * 0.07, context.currentTime);
    gain.gain.exponentialRampToValueAtTime(
      0.001,
      context.currentTime + (kind === 'warning' ? 0.22 : 0.08),
    );
    oscillator.connect(gain).connect(context.destination);
    oscillator.start();
    oscillator.stop(context.currentTime + 0.25);
  }
}
